import type { SimulatorProfileDefinition } from "../contracts/appManifest.js";

export const workstationProfile: SimulatorProfileDefinition = {
  id: "workstation",
  title: "FirstDesk Workstation",
  productLabel: "FirstDesk Workstation",
  machineRole: "client",
  theme: "workstation",
  desktopAppIds: ["explorer", "settingsSystem", "cmd", "lusrmgr", "ncpa", "sysdm"],
  pinnedAppIds: ["explorer", "settingsSystem", "cmd", "lusrmgr"],
  defaultOpenAppIds: [],
  startMenuSections: [
    {
      title: "Pinned",
      appIds: ["explorer", "settingsSystem", "cmd", "lusrmgr", "notepad", "paint", "calc", "snippingTool"]
    },
    {
      title: "Admin tools",
      appIds: ["ncpa", "sysdm", "remoteDesktop", "controlPrinters", "services", "eventvwr", "taskschd", "taskmgr", "wf"]
    }
  ]
};
